import React from "react";

export function Footer() {
  return (
    <footer className="mt-8 pt-6 pb-6 border-t border-slate-200 dark:border-slate-800 flex items-center justify-center">
      <p className="text-sm text-muted-foreground font-medium text-center">
        &copy; 2026 <a href="https://xeroalpha.com/" 
  target="_blank"    rel="noopener noreferrer"
   className="text-indigo-600 hover:text-green-500">
   XeroAlpha
</a> All rights reserved.
      </p>
    </footer>
  );
}
